var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.973 15.947a7.976 7.976 0 007.974-7.974A7.976 7.976 0 007.973 0 7.975 7.975 0 000 7.973a7.976 7.976 0 007.973 7.974zm.956-6.312H7.008c-.197 0-.353-.115-.353-.26l-.177-6.447c0-.073.032-.146.104-.187a.4.4 0 01.25-.083h2.283a.4.4 0 01.25.083.208.208 0 01.103.187l-.186 6.447c-.01.145-.167.26-.353.26zm-1.942 3.654H8.98c.177 0 .322-.156.322-.343v-1.972c0-.187-.145-.343-.322-.343H6.987a.346.346 0 00-.342.343v1.972c0 .187.155.343.342.343z",
    fill: "currentColor"
  })));
}
export default SvgWarningCircle;